import React from 'react'
import ReactDOM from 'react-dom'
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles'
import orange from '@material-ui/core/colors/orange'
import grey from '@material-ui/core/colors/grey'
import './index.scss'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { ToastContextProvider } from '../src/contexts/toastContext'
import './variables.scss'

const theme = createMuiTheme({
  palette: {
    // type: 'dark',
    primary: {
      main: '#3068F9',
    },
    secondary: {
      main: '#EDF2FF',
    },
  },
  overrides: {
    MuiFab: {
      label: {
        color: 'white',
      },
    },
    TimePicker: {
      color: 'white',
      borderColor: 'white',
    },
    MuiButton: {
      label: {
        color: 'white',
      },
      contained: {
        textTransform: 'none',
        color: 'white',
      },
      outlined: {
        textTransform: 'none',
        color: 'white',
      },
      root: {
        '& .Mui-error': {
          color: 'white',
        },
      },
    },

    // MuiTypography: {
    //   root: {
    //     color: '#444444',
    //   },
    // },
    MuiButtonLabel: {
      root: {
        color: '#444444',
      },
    },
  },
  props: {
    MuiButtonBase: {
      disableRipple: true,
    },
  },
})

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <ToastContextProvider>
        <App />
      </ToastContextProvider>
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
